function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgMusicaEHobbies = function SvgMusicaEHobbies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.034 9.153l.437-.077v7.226a3.5 3.5 0 101 2.45V8.9l9.5-1.676v7.578a3.5 3.5 0 101 2.45V6.826a2 2 0 00.765-1.944l-.261-1.477a2 2 0 00-2.318-1.622L7.08 3.737a2 2 0 00-1.622 2.317l.26 1.476a2 2 0 002.317 1.623zm10.937 8.098a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0zm-13-1a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm13.78-11.195a1 1 0 01-.812 1.158L7.86 8.167a1 1 0 01-1.158-.811l-.26-1.477a1 1 0 01.81-1.159l11.08-1.953a1 1 0 011.158.811l.261 1.478z",
    fill: props.color
  }));
};

SvgMusicaEHobbies.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgMusicaEHobbies.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgMusicaEHobbies;